import isNullOrEmpty from "../helpers/isNullOrEmpty";
import {ProblemDetails} from './ProblemDetails.js';

function getErrorTitle(response: Response): string {
	if (response.status === 0) {
		if (isNullOrEmpty(response.statusText)) {
			return "Opaque response to no-cors request"
		}

		return `${response.statusText}`;
	}

	if (isNullOrEmpty(response.statusText)) {
		return `[${response.status}]`;
	}

	return `[${response.status}] - ${response.statusText}`;
}

function getErrorMessage(response: Response | null): string {
	if (response == null) {
		return "Connection error";

	} else {
		return `${getErrorTitle(response)} @ ${response.url}`
	}
}

class HttpClientError extends Error {
	problemDetails: ProblemDetails;
	request: RequestInit | null | undefined;
	response: Response | null | undefined;

	constructor(problemDetails: ProblemDetails, request: RequestInit | null, response: Response | null) {
		super(getErrorMessage(response));

		this.problemDetails = problemDetails;
		this.request = request;
		this.response = response;
	}

	get status(): number {
		return this.problemDetails.status ?? this.response?.status ?? 0;
	}

	getRequestHeader(headerName: string): string | null {
		let headers = this.request?.headers;
		if (headers == null) {
			return null;
		}

		if (!(headers instanceof Headers)) {
			headers = this.request!.headers = new Headers(headers);
		}

		return headers.get(headerName);
	}
}

export {HttpClientError};
